<template>
  <div class="s-sep">
    <span class="s-sep__wing"></span>

    <span class="s-sep__label">{{ label }}</span>

    <span class="s-sep__wing"></span>
  </div>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
      },
    },
  };
</script>

<style scoped lang="scss">
  .s-sep {
    width: calc(100% - 24px);
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;

    & > * {
      display: inline-block;
    }

    &__wing {
      background: lightgray;
      height: 1px;
      width: 100%;
    }

    &__label {
      margin: 0 8px;
      white-space: nowrap;
    }
  }
</style>
